import React from 'react'
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
      <a href="https://www.linkedin.com/in/hospice-hounfodji-44a2a7235/" target='_blank' rel="noreferrer"><FaLinkedin /></a>
      <a href="https://github.com/hounfodji" target='_blank' rel="noreferrer"><FaGithub /></a>
      <a href="https://www.instagram.com/hospice_6/?igsh=ZnFmdGZ6aWIzOXZy" target='_blank' rel="noreferrer"><FaInstagram /></a>
    </div>
  )
}

export default HeaderSocials
